import { selectComponentState } from 'projectRedux/store';
import { eppDiameterAdapter } from '../adapters/eppDiameterAdapter';

export const {
  selectAll: selectAllEppDiameters,
  selectById: selectEppDiameterById,
  selectEntities: selectEppDiameterEntities,
} = eppDiameterAdapter.getSelectors((state) => selectComponentState(state).eppDiameters);
